import Mixin from '../Mixin';
import FDictionaryServiceAdditional from '@/modules/Dictionary/ServiceAdditional/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  additional = new FDictionaryServiceAdditional({
    label: 'Виза',
    required: true,
  });

  constructor(props) {
    super(props);
    this.service.set({
      value: 5,
      label: 'Виза',
    });
    this.setItems([
      ['additional', this.additional],
    ]);
    this.additional.service = this.service;
    this.additional.country = this.country;
    this.additional.city = this.city;
  }


  set(value = {}) {
    super.set(value);
    this.__set('additional', value.additional, null);
    return this;
  }

  toString() {
    return this.additional.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.additional.toLabel();
        return data;
      });
  }
}
